import Intercom, { show } from '@intercom/messenger-js-sdk'

import type { UserContextType } from '@/client/context/user'
import isUserDefined from '@/client/services/user/isUserDefined'

export const INTERCOM_APP_ID = 'o6cu22jm'

export { show as showIntercomMessenger }

export function initIntercom({
  user,
  intercomUserHash,
}: {
  user: UserContextType
  intercomUserHash: string | null
}): void {
  Intercom({
    app_id: INTERCOM_APP_ID,
    ...(isUserDefined(user) && intercomUserHash != null
      ? {
          user_id: `${user.id}`,
          name: user.displayName,
          email: user.email,
          created_at: Math.floor(new Date(user.createdAt).getTime() / 1000),
          hide_default_launcher: true,
          user_hash: intercomUserHash,
        }
      : {}),
  })
}
